import Header from 'component/layout/header/Header';
import BackHeader from 'component/molecules/back-header/BackHeader';
import ProfileTemplate from 'component/organism/profile/ProfileTemplate';
import styles from './Profile.module.scss';
import React from 'react';

const Profile = ({ isUserChat = false }) => {
  return (
    <>
      {isUserChat ? (
        <BackHeader label='Back to chat' />
      ) : (
        <Header title='My Profile' />
      )}
      <div
        className={`${isUserChat ? styles['profile-container'] : styles['aiProfile-container']}`}
      >
        {isUserChat && <Header title='My Profile' />}
        <ProfileTemplate />
      </div>
    </>
  );
};

export default Profile;
